<template>
	<div
		class="c-panel__inner"
		v-click-outside="clickOutside"
		:class="{ 'is-wide': isWide }"
	>
		<div class="c-panel__header">
			<div class="c-panel__close" @click="closePanel">
				<icon name="cross" width="21" height="21"></icon>
			</div>
			<slot name="header">
				<h2 class="c-panel__header-title u-hide-mobile">{{ headerTitle }}</h2>
			</slot>
			<div class="c-panel__actions">
				<slot name="actions"></slot>
			</div>
		</div>

		<div class="c-panel__container">
			<div class="c-panel__content" :style="contentStyleObject">
				<slot></slot>
				<spacer :size="400"></spacer>
			</div>
		</div>
	</div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import watermarkImg from '@/assets/images/mft-watermark.png'

export default {
	name: 'side-panel-inner',

	props: {
		headerTitle: String,
		onClose: String,
		isWide: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			//
		}
	},

	methods: {
		clickOutside($e) {
			if ($e.target.classList.contains('is-open')) {
				this.closePanel() // shrug
			}
		},
		closePanel() {
			this.$store.dispatch('CLOSE_PANEL', this.onClose)
		},
	},

	computed: {
		contentStyleObject() {
			return {
				backgroundImage: `url(${this.watermarkImgSrc})`,
			}
		},

		watermarkImgSrc: () => watermarkImg,
	},

	directives: {
		ClickOutside,
	},
}
</script>

<style lang="scss">
.c-panel__header-title {
	font-size: 20px;
	font-family: $font-family-primary;
	font-weight: normal;
	color: #202020;
	flex-grow: 1;
}

.c-panel__close {
	border-right: 1px solid $colour-nhs-pale-grey;
	color: #c9ced4;
	padding: 0 2.25em;
	height: 100%;
	margin-right: 1.5em;
	display: flex;
	align-items: center;
	cursor: pointer;
}

.c-panel__header {
	background: rgba(255, 255, 255, 1);
	z-index: 72;
	box-shadow: 0 1px 1px rgba(0, 0, 0, 0.08);
	transition: transform 0.3s 0s;
	transform: translateY(-100px);

	padding: 0 2em 0 0;

	height: 90px;

	display: flex;
	justify-content: space-between;
	align-items: center;

	position: absolute;
	left: 0;
	right: 0;
	max-width: 100%;
}

.c-panel__actions {
	display: flex;
	align-items: center;
}

.c-panel__inner {
	position: fixed;
	width: 100%;
	@media (min-width: 768px) {
		width: 90%;
		max-width: 860px;
	}
	height: 100%;
	top: 0;
	display: flex;
	background-color: #f0f5fb;

	z-index: 71;
	transition: transform 0.3s 0.3s;

	&.is-wide {
		@media (min-width: 768px) {
			max-width: 90%;
		}
	}
}

.c-panel__content {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	padding-top: 100px;
	padding-left: 10px;
	padding-right: 10px;
	@media screen and (min-width: 1024px) {
		padding-left: 2em;
		padding-right: 2em;
	}

	overflow: auto;
	/* smooth scrolling on touch devices */
	-webkit-overflow-scrolling: touch;

	background-size: 360px 350px;
	background-position: 100% 100%;
}

@media only screen and (min-width: 1024px) {
	.c-panel__inner {
		width: 70%;
	}

	&.is-wide {
		width: 90%;
		max-width: 90%;
	}

	.c-panel__content {
		padding-left: 3em;
		padding-right: 3em;

		&.is-wide {
			padding-left: 1em;
			padding-right: 1em;
		}
	}
}

@media only screen and (min-width: 1170px) {
	.c-panel__inner {
		width: 60%;
	}

	&.is-wide {
		width: 90%;
		max-width: 90%;
	}

	.c-panel__content {
		padding-left: 6em;
		padding-right: 6em;

		&.is-wide {
			padding-left: 2em;
			padding-right: 2em;
		}
	}
}
</style>
